<template>
  <div class="courses-page container mt-5 pt-4">
    <h2 class="mb-4 text-primary">All Courses</h2>
    <div class="row g-4">
      <div class="col-md-4" v-for="course in courses" :key="course.id">
        <div class="card h-100 shadow-sm">
          <img :src="course.image" class="card-img-top" :alt="course.title" />
          <div class="card-body d-flex flex-column">
            <h5 class="card-title">{{ course.title }}</h5>
            <p class="card-text flex-grow-1">{{ course.description }}</p>
            <router-link :to="`/courses/${course.id}`" class="btn btn-primary mt-2">
              Learn More
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";

const courses = ref([
  {
    id: 1,
    title: "HTML & CSS Basics",
    description: "Learn the fundamentals of web development with HTML and CSS.",
    image: require("@/assets/courses/html-css.jpg"),
  },
  {
    id: 2,
    title: "JavaScript for Beginners",
    description: "Understand JavaScript basics to make interactive web pages.",
    image: require("@/assets/courses/js.jpg"),
  },
  {
    id: 3,
    title: "Vue 3 Fundamentals",
    description: "Build reactive web applications using Vue 3 and Composition API.",
    image: require("@/assets/courses/vue3.jpg"),
  },
  {
    id: 4,
    title: "Laravel 11 Basics",
    description: "Learn backend development with Laravel 11.",
    image: require("@/assets/courses/laravel.jpg"),
  },
]);
</script>
